module.exports = __webpack_public_path__ + "img/16-1px-delete.703c6b5.svg";